export default __webpack_public_path__ + "static/media/assessment.338e0767.mp4";